import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../../../utils/utils';
// forwardRef because consumers read the value off a ref (uncontrolled forms);
// without it React 18 drops the ref and the field reads as empty.
export const Textarea = forwardRef(function Textarea({ className, ...props }, ref) {
    return (_jsx("textarea", { ...props, ref: ref, className: cn('shadow-sm rounded-lg border border-solid bg-white border-neutral-200 pl-2 pr-2 py-2 font-roobert text-sm text-gray-900 placeholder:text-neutral-400 outline-none w-full', className) }));
});
